import * as React from 'react';

import { ColorPicker } from './ColorPicker';

import Dropdown from '../../custom-components/icon-text-button/Dropdown';

interface ColorPickerDropdownProps extends React.Props<ColorPickerDropdown> {
    Icon: React.ReactElement<__MaterialUI.SvgIconProps>;
    text: string;
    hexColor: string;
    initialMode?: number;
    recentColors?: string[];
    onChange?: (hexColor: string, isDefaultColor: boolean) => void;
}

interface ColorPickerDropdownState {
    isExpanded: boolean;
    isCloseable: boolean;
}

export class ColorPickerDropdown extends React.Component<ColorPickerDropdownProps, ColorPickerDropdownState> {

    constructor(props: ColorPickerDropdownProps) {
        super(props);

        this.state = {
            isExpanded: false,
            isCloseable: true
        };
    }

    render() {
        const styles = this.getStyles();

        return (
            <Dropdown
                isSmart={false}
                isExpanded={this.state.isExpanded}
                onOpen={() => this.setState({ isExpanded: true } as ColorPickerDropdownState)}
                onClose={() => {
                    if (this.state.isCloseable) {
                        this.setState({ isExpanded: false } as ColorPickerDropdownState);
                    }
                }}
                Icon={this.props.Icon}
                text={this.props.text}
                popoverChildrenStyle={styles.popoverChildren}
            >
                <ColorPicker
                    hexColor={this.props.hexColor}
                    initialMode={this.props.initialMode}
                    recentColors={this.props.recentColors}
                    onChange={this.onColorChange}
                    onCancel={() => this.setState({ isExpanded: false } as ColorPickerDropdownState)}
                    onDragChange={(isMouseDown) => {

                        // We need to wait for the next event loop cycle, because
                        // the `onClose` callback on `Dropdown` gets invoked before this callback.
                        setTimeout(() => {
                            this.setState({ isCloseable: !isMouseDown } as ColorPickerDropdownState);
                        }, 0);
                    }}
                />
            </Dropdown>
        );
    }

    private onColorChange = (hexColor: string, isDefaultColor: boolean) => {
        this.setState({ isExpanded: false } as ColorPickerDropdownState);

        if (this.props.onChange) {
            this.props.onChange(hexColor, isDefaultColor);
        }
    };

    private getStyles() {
        return {
            popoverChildren: {
                padding: 0
            }
        };
    }

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/color-picker/ColorPickerDropdown.tsx
 **/